import React, { ReactNode } from "react";
import {
  Box,
  Center,
  Flex,
  Image,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { mdScale } from "@/stores/theme";

interface Props {
  isOpen: boolean;
  onClose(): void;
  title: string | ReactNode;
  desc: string | ReactNode;
  footerText: string;
  onBtnClick(): void;
  modalBgImage?: string;
  btnText?: string;
}

const goldGradient = `linear-gradient(#FEF5DA, #E6C48C);`;

const genResponsivePx = (lg: number) => ({ base: `${lg * mdScale}px`, lg: `${lg}px` });

export default function HeartCoinPaySuccessModal(props: Props) {
  const {
    isOpen,
    onClose,
    title,
    footerText,
    onBtnClick,
    desc,
    modalBgImage = "http://nolipix-js.nolibox.com/assets/creator/wenxin_modal_bg.png",
    btnText = "我知道了",
  } = props;
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent
        pos="relative"
        zIndex={0}
        maxW={genResponsivePx(400)}
        maxH={genResponsivePx(600)}
        rounded={genResponsivePx(20)}
        bgColor="transparent"
        overflow="hidden"
      >
        {modalBgImage ? (
          <Image zIndex={-1} pos="absolute" w="100%" left="0" top="0" src={modalBgImage} />
        ) : null}
        <ModalCloseButton color="white" mt={genResponsivePx(50)} />
        <Flex
          w={genResponsivePx(400)}
          h={genResponsivePx(600)}
          flexDir="column"
          color="black"
          align="center"
          pt={genResponsivePx(48)}
        >
          <Flex flexDir="column" h={genResponsivePx(353)} align="center">
            {typeof title === "string" ? (
              <Text
                fontWeight={600}
                mt={genResponsivePx(144)}
                mb={genResponsivePx(11)}
                fontSize={genResponsivePx(36)}
              >
                {title}
              </Text>
            ) : (
              title
            )}
            <Flex justify="center">
              {typeof desc === "string" ? <Text fontSize={genResponsivePx(24)}>{desc}</Text> : desc}
            </Flex>
          </Flex>

          <Center flexDir="column" p={`1px 0 8px`} flex={1}>
            <Text color="#999999" fontSize={genResponsivePx(12)}>
              {footerText}
            </Text>
            <Flex
              as="button"
              mt={genResponsivePx(16)}
              w={genResponsivePx(216)}
              h={genResponsivePx(50)}
              rounded="full"
              align="center"
              justify="center"
              bg={goldGradient}
              onClick={onBtnClick}
            >
              <Text color="black" fontSize={genResponsivePx(24)} fontWeight={500}>
                {btnText}
              </Text>
            </Flex>
          </Center>
        </Flex>
      </ModalContent>
    </Modal>
  );
}
